import React from "react";
import { formatMoney } from "accounting-js";
import PriceFlag from "./PriceFlag";
import { connect } from "react-redux";
import {
  setIsPrimary,
  setTargetHardwareTotal,
  setTargetSoftwareTotal
} from "../redux/actions";
import {
  isGovernmentOpportunity,
  isTargetHardwareTotalValid,
  isTargetSoftwareTotalValid,
  isTargetSaasTotalValid,
  mspSoftwareTotal,
  mspHardwareTotal,
  mspSaasTotal,
  mspTotal,
  targetTotal,
  targetTotalCash,
  targetTotalFinance,
  effectiveMspHardwareTotal,
  effectiveMspSoftwareTotal
} from "../redux/selectors";
import { totalMinimumCharge } from "../redux/selectors/finance";
import style from "./Totals.module.css";
import { OnBlurInput } from "./OnBlurInput";
import { HARDWARE_DISCOUNT, SOFTWARE_DISCOUNT, OPPORTUNITY_TYPES_NO_DISCOUNT, IS_NZ } from "../constants";
import { Card, Accordion, Form, Row, Col, InputGroup } from "react-bootstrap";

function Totals(props) {
  return (
    <Accordion defaultActiveKey="totals" className={style.root}>
      <Card border="primary">
        <Accordion.Toggle
          eventKey="totals"
          as={Card.Header}
          className={`${style.cardHeader} dropdown-toggle bg-primary text-white`}
        >
          Totals
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="totals">
          <Card.Body>
            {props.mspHardwareTotal > 0 && (
              <>
                <Form.Group as={Row}>
                  <Form.Label sm={5} column>
                    Total Hardware MSP
                  </Form.Label>
                  <Col sm={7}>
                    <p className="form-control-plaintext">
                      {formatMoney(props.mspHardwareTotal)}
                    </p>
                  </Col>
                </Form.Group>
              </>
            )}
            {props.mspSoftwareTotal > 0 && (
              <>
                <Form.Group as={Row}>
                  <Form.Label sm={5} column>
                    Total Software MSP
                  </Form.Label>
                  <Col sm={7}>
                    <p className="form-control-plaintext">
                      {formatMoney(props.mspSoftwareTotal)}
                    </p>
                  </Col>
                </Form.Group>
              </>
            )}
            {props.mspSaasTotal > 0 && (
              <>
                <Form.Group as={Row}>
                  <Form.Label sm={5} column>
                    Total SaaS MSP
                  </Form.Label>
                  <Col sm={7}>
                    <p className="form-control-plaintext">
                      {formatMoney(props.mspSaasTotal)}
                    </p>
                  </Col>
                </Form.Group>
              </>
            )}

            <Form.Group as={Row}>
              <Form.Label sm={5} column>
                Total MSP
              </Form.Label>
              <Col sm={7}>
                <p className="form-control-plaintext">
                  {formatMoney(props.mspTotal)}
                </p>
              </Col>
            </Form.Group>

            {props.mspHardwareTotal > 0 && (
              <Form.Group as={Row} controlId="targetHardwareTotal">
                <Form.Label sm={5} column>
                  Total Hardware
                </Form.Label>

                <Col sm={7}>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>$</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      as={OnBlurInput}
                      isInvalid={!props.isTargetHardwareTotalValid}
                      type="number"
                      min={
                        OPPORTUNITY_TYPES_NO_DISCOUNT.includes(props.opportunityType)
                        ? props.mspHardwareTotal 
                        : props.mspHardwareTotal * HARDWARE_DISCOUNT}
                      max={
                        OPPORTUNITY_TYPES_NO_DISCOUNT.includes(props.opportunityType)
                        ? props.mspHardwareTotal
                        : null
                      }
                      value={props.targetHardwareTotal}
                      onConfirm={e =>
                        props.setTargetHardwareTotal(e.target.value)
                      }
                      disabled={
                        props.isMsa || props.effectiveMspHardwareTotal === 0 || OPPORTUNITY_TYPES_NO_DISCOUNT.includes(props.opportunityType)
                      }
                    />
                  </InputGroup>
                </Col>
              </Form.Group>
            )}

            {props.mspSoftwareTotal > 0 && (
              <Form.Group as={Row} controlId="targetSoftwareTotal">
                <Form.Label sm={5} column>
                  Total Software
                </Form.Label>
                <Col sm={7}>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>$</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      as={OnBlurInput}
                      isInvalid={!props.isTargetSoftwareTotalValid}
                      type="number"
                      min={
                        OPPORTUNITY_TYPES_NO_DISCOUNT.includes(props.opportunityType)
                        ? props.mspSoftwareTotal
                        : props.mspSoftwareTotal * SOFTWARE_DISCOUNT}
                      max={
                        OPPORTUNITY_TYPES_NO_DISCOUNT.includes(props.opportunityType)
                        ? props.mspSoftwareTotal
                        : props.mspSoftwareTotal * 1.5
                      }
                      value={props.targetSoftwareTotal}
                      onConfirm={e =>
                        props.setTargetSoftwareTotal(e.target.value)
                      }
                      disabled={
                        props.isMsa || props.effectiveMspSoftwareTotal === 0 || OPPORTUNITY_TYPES_NO_DISCOUNT.includes(props.opportunityType)
                      }
                    />
                  </InputGroup>
                </Col>
              </Form.Group>
            )}

            {props.mspSaasTotal > 0 && (
              <Form.Group as={Row} controlId="targetSaasTotal">
                <Form.Label sm={5} column>
                  Total SaaS
                </Form.Label>

                <Col sm={7}>
                  <InputGroup>
                    <InputGroup.Prepend>
                      <InputGroup.Text>$</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                      as={OnBlurInput}
                      isInvalid={!props.isTargetSaasTotalValid}
                      type="number"
                      min={
                        OPPORTUNITY_TYPES_NO_DISCOUNT.includes(props.opportunityType)
                        ? props.mspSaasTotal 
                        : props.mspSaasTotal * SOFTWARE_DISCOUNT}
                      max={
                        OPPORTUNITY_TYPES_NO_DISCOUNT.includes(props.opportunityType)
                        ? props.mspSaasTotal
                        : null
                      }
                      value={props.targetSaasTotal}
                      disabled={ true } //SaaS Target Total cannot be changes from quote page. Use Product page
                    />
                  </InputGroup>
                </Col>
              </Form.Group>
            )}

            <Form.Group as={Row}>
              <Form.Label sm={5} column>
                Total Cash
              </Form.Label>
              <Col sm={7}>
                <p className="form-control-plaintext">
                  {formatMoney(props.targetTotalCash)}
                </p>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label sm={5} column>
                Total Financed
              </Form.Label>
              <Col sm={7}>
                <p className="form-control-plaintext">
                  {formatMoney(props.targetTotalFinance)}
                </p>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label sm={5} column>
                Total Price
              </Form.Label>
              <Col sm={7}>
                <p className="form-control-plaintext">
                  {formatMoney(props.targetTotal)}
                </p>
              </Col>
            </Form.Group>
            
            { !IS_NZ ?
              (
                <Form.Group as={Row} controlId="tmc">
                  <Form.Label sm={5} column>
                    Total TMC
                  </Form.Label>
                  <Col sm={7}>
                  <p className="form-control-plaintext">
                    {formatMoney(props.totalMinimumCharge)}
                  </p>
                  </Col>
                </Form.Group>
              )
              : null
            }

            { !IS_NZ ?
              (
                <Form.Group as={Row} controlId="priceFlag">
                  <Form.Label sm={5} column>
                    Price Flag
                  </Form.Label>
                  <Col sm={7}>
                    <PriceFlag />
                  </Col>
                </Form.Group>
              )
              : null
            }
            

            <Form.Group as={Row}>
              <Col sm={{ span: 7, offset: 5 }}>
                <Form.Check
                  id="isPrimary"
                  type="checkbox"
                  checked={props.isPrimary}
                  onChange={e => props.setIsPrimary(e.target.checked)}
                  label="Set as primary quote"
                />
              </Col>
            </Form.Group>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

export default connect(
  state => ({
    isMsa: state.quote.isMsa,
    isPrimary: state.quote.isPrimary,
    isGovernmentOpportunity: isGovernmentOpportunity(state),

    isTargetHardwareTotalValid: isTargetHardwareTotalValid(state),
    isTargetSoftwareTotalValid: isTargetSoftwareTotalValid(state),
    isTargetSaasTotalValid: isTargetSaasTotalValid(state),

    mspSoftwareTotal: mspSoftwareTotal(state),
    mspHardwareTotal: mspHardwareTotal(state),
    mspSaasTotal: mspSaasTotal(state),
    mspTotal: mspTotal(state),

    targetSoftwareTotal: state.quote.targetSoftwareTotal,
    targetHardwareTotal: state.quote.targetHardwareTotal,
    targetSaasTotal: state.quote.targetSaasTotal,
    targetTotal: targetTotal(state),
    targetTotalCash: targetTotalCash(state),
    targetTotalFinance: targetTotalFinance(state),

    effectiveMspHardwareTotal: effectiveMspHardwareTotal(state),
    effectiveMspSoftwareTotal: effectiveMspSoftwareTotal(state),

    opportunityType: state.opportunity.OpportunityType,
    totalMinimumCharge: totalMinimumCharge(state)

  }),
  { setIsPrimary, setTargetSoftwareTotal, setTargetHardwareTotal }
)(Totals);
